import { render, staticRenderFns } from "./EventTab.vue?vue&type=template&id=dd49e21c&scoped=true"
import script from "./EventTab.vue?vue&type=script&lang=js"
export * from "./EventTab.vue?vue&type=script&lang=js"
import style0 from "./EventTab.vue?vue&type=style&index=0&id=dd49e21c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd49e21c",
  null
  
)

export default component.exports